module.exports = __webpack_public_path__ + "static/media/tick.9b223f00.svg";